var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19C2.45 19 1.97917 18.8042 1.5875 18.4125C1.19583 18.0208 1 17.55 1 17V7C1 6.45 1.19583 5.97917 1.5875 5.5875C1.97917 5.19583 2.45 5 3 5H13C13.55 5 14.0208 5.19583 14.4125 5.5875C14.8042 5.97917 15 6.45 15 7V17C15 17.55 14.8042 18.0208 14.4125 18.4125C14.0208 18.8042 13.55 19 13 19H3ZM18 11C17.7167 11 17.4792 10.9042 17.2875 10.7125C17.0958 10.5208 17 10.2833 17 10V6C17 5.71667 17.0958 5.47917 17.2875 5.2875C17.4792 5.09583 17.7167 5 18 5H22C22.2833 5 22.5208 5.09583 22.7125 5.2875C22.9042 5.47917 23 5.71667 23 6V10C23 10.2833 22.9042 10.5208 22.7125 10.7125C22.5208 10.9042 22.2833 11 22 11H18ZM19 9H21V7H19V9ZM3 17H13V7H3V17ZM18 19C17.7167 19 17.4792 18.9042 17.2875 18.7125C17.0958 18.5208 17 18.2833 17 18V14C17 13.7167 17.0958 13.4792 17.2875 13.2875C17.4792 13.0958 17.7167 13 18 13H22C22.2833 13 22.5208 13.0958 22.7125 13.2875C22.9042 13.4792 23 13.7167 23 14V18C23 18.2833 22.9042 18.5208 22.7125 18.7125C22.5208 18.9042 22.2833 19 22 19H18ZM19 17H21V15H19V17Z",
    fill: "#3F484B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout);
export default __webpack_public_path__ + "static/media/Layout.e57f2ba0406d0435689e1308319e676a.svg";
export { ForwardRef as ReactComponent };